import { ActionType, useActionState } from "../../../status/state/actions.state";

import Button from '@ingka/button';
import { StyledTooltip } from "../../../../shared/styles/components/integrations.styles";
import styled from '@emotion/styled';
import { useGetBulkEditItemsFromSelection } from './bulk-edit.state';

export const BulkEditEditButton = () => {
   const { onlyLockedSubItems } = useGetBulkEditItemsFromSelection();

   const tooltipText = onlyLockedSubItems ? 'You need to make a selection with unlocked materials before bulk editing' : 'Bulk edit selections';

   return (
      <StyledTooltip title={tooltipText} placement={'top'}>
         <div style={{ marginLeft: '.5rem' }}>
            <StyledEditButton
               text={'Edit'}
               small={true}
               type={'emphasised'}
               onClick={() => useActionState.setState({ actionType: ActionType.bulkEditing })}
               disabled={onlyLockedSubItems}
            />
         </div>
      </StyledTooltip>
   );
};

const StyledEditButton = styled(Button)`
   min-width: 8rem;
`;
